import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';

@Component({
  selector: 'app-label-sequential-code',
  templateUrl: './label-sequential-code.component.html',
  styleUrls: ['./label-sequential-code.component.scss']
})
export class LabelSequentialCodeComponent extends ComponentBase implements OnInit {

  constructor() { super() }

  ngOnInit() {

  }
}
